import script from "./NewsItem2.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsItem2.vue?vue&type=script&setup=true&lang=js"

import "./NewsItem2.vue?vue&type=style&index=0&id=4d91e4f5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d91e4f5"]])

export default __exports__